import { reactive, onBeforeUnmount, onMounted, computed } from '@vue/composition-api'
import handleValueOrFunction from '@iez/lib/handle-value-or-function'

/**
 * Resee bottom shortcut management
 * to handle value or function !
 */
export const state = reactive({
  bottomShortcut: null
})

export default () => {
  const methods = {
    /**
     * action ( icon, label )
     */
    add: bottomShortcut => {
      onMounted(() => {
        handleValueOrFunction({
          valueOrFunction: bottomShortcut,
          callback: bottomShortcut => {
            if (bottomShortcut) {
              state.bottomShortcut = bottomShortcut
            } else {
              state.bottomShortcut = null
            }
          }
        })
      })

      onBeforeUnmount(() => {
        state.bottomShortcut = null
      })

      return computed(
        () => state.bottomShortcut
      )
    }
  }

  return {
    state,
    ...methods
  }
}
